import Mustache from 'mustache'
import _ from 'lodash'

class Templater {

    matches = []
    stringKeys = []

    cleanupTemplate(template, view)
    {
        this.matches = [];
        this.stringKeys = {};

        // find and replace any ternary actions and replace with mustache conditional syntax
        template = this._replaceHardCodedStrings(template, view);
        // Mustache cannot handle lodash functions, remove them but leave the arguments
        template = this._removeLodashFunctions(template, view);

        // temporarily replace strings with ":"" in them
        template = this._setTempStrings(template, view);
        
        // Mustache cannot handle ternary operators, replace with mustache conditional syntax
        template = this._cleanupSimpleTernary(template, view);

        // Replace any string concatenation with mustache syntax
        template = this._replaceConcatStrings(template, view);

        // Put the colon strings back in
        template = this._setFinalConcatStrings(template, view);

        return template;
    }

    _replaceHardCodedStrings(template, view)
    {
        const _templateNoSpaces = template.replace(/\s+/g, '')

        let _replacement = null
        let _function = null

        // Section for heavy logic and hardcoded string replacements
        switch (_templateNoSpaces) {
            case "<%if(item.isCategory){print(1);}%>":
                _replacement = '<%=#item%><%=templateFunction%><%=/item%>';
                _function = function() {
                    return (this.isCategory) ? 1 : ''
                }
                break;
            case "<%if(item.id!=='graphic'){print(1);}%>":
                _replacement = '<%=#item%><%=templateFunction%><%=/item%>';
                _function = function() {
                    return (this.id !== 'graphic') ? 1 : ''
                }
                break;
            case "<%if(item.include){print(1);}%>":
                _replacement = '<%=#item%><%=templateFunction%><%=/item%>';
                _function = function() {
                    return (this.include) ? 1 : ''
                }
                break;
            case "<%if(!(item.id==='$_name'||item.id==='graphic'||item.id==='id'||item.id==='topTerm'||item.id==='appearInTray'||item.id==='groups'||item.id==='expertTips')){print(1);}%>":
                _replacement = '<%=#item%><%=templateFunction%><%=/item%>';
                _function = function() {
                    return (!(this.id === '$_name' || this.id === 'graphic' || this.id === 'id' || this.id === 'topTerm' || this.id === 'appearInTray' || this.id === 'groups' || this.id === 'expertTips')) ? 1 : ''
                }
                break;
            case "<%if(!(item.id==='$_name'||item.id==='graphic')){print(1);}%>":
                _replacement = '<%=#item%><%=templateFunction%><%=/item%>';
                _function = function() {
                    return (!(this.id === '$_name' || this.id === 'graphic')) ? 1 : ''
                }
                break;
            case "Panel<%=i1%><%if(_.get(self,'cause.$_title')){%>(<%=self.cause.$_title%>)<%}%>":
                _replacement = 'Panel <%=i1%> <%=#self%><%=templateFunction%><%=/self%>';
                _function = function() {
                    return (this.cause.$_title) ? " ("+this.cause.$_title+")" : ''
                }
                break;
            case "Question<%=String.fromCharCode(Number(i)+65)%>":
                _replacement = 'Question <%=#i%><%=templateFunction%><%=/i%><%=^i%>A<%=/i%>';
                _function = function() {
                    return String.fromCharCode(Number(this) + 65)
                }
                break;
            case "(<%=i+1%>)<%=_.truncate(item.$_response,{length:30})%>":
                _replacement = '(<%=i%>) <%=#item.$_response%><%=templateFunction%><%=/item.$_response%>';
                _function = function() {
                    return _.truncate(this, {length: 30});
                }
                break;
            default:
                break;
        }

        if (view && _replacement !== null && _function !== null) {
            template = _replacement
            view.templateFunction = _function
        }

        // END SECION //
        // replace single quotes from schema with doubles for regex processing
        template = template.replaceAll("'", '"');

        // replace increment calls with simple var
        template = template.replaceAll("(i + 1)", "i");
        template = template.replaceAll("i + 1", "i");
        template = template.replaceAll('(self.$_name)', 'self.$_name');

        template = template.replaceAll("self.content && self.content.$_title", "self.content.$_title");

        template = template.replaceAll(".substr(0, 50)", "");

        template = template.replaceAll("watched.useCustomResponses === true", "watched.useCustomResponses");

        // Mustache new templater treats ! as comments and ignores the value part, replace with correct conditional syntax
        template = template.replace(/<%= !!val %>/g, "<%=#val%>true<%=/val%><%=^val%>false<%=/val%>");

        return template;
    }

    _removeLodashFunctions(template)
    {
        let simpleLodashFunctions = ['startCase', 'upperFirst', 'truncate', 'capitalize'];
        simpleLodashFunctions.forEach (func => {
            let regex = new RegExp(`(<%=){1}(.+)(_\\.${func}\\()([^%)]+)+?(\\)){1}([^%]+)*(%>){1}`, 'g');

            while (regex.test(template))
            {
                this.matches.push('lodashFunctions');
                template = template.replace(regex, `$1$2$4$6$7`);
            }
        });

        let complexLodashFunctions = ['replace', 'get']; // get is special case
        complexLodashFunctions.forEach (func => {
            let regex = new RegExp(`(<%=){1}(.+)(_\\.${func}\\()([^,]+)([^%)]+)+?(\\)){1}([^%]+)*(%>){1}`, 'g');

            while (regex.test(template))
            {
                this.matches.push('lodashFunctions');
                template = template.replace(regex, `$1$2$4$7$8`);
            }
        });

        return template;
    }

    _setTempStrings(template)
    {
        let regex = /"([^%]*?)"/g;
        template = template.replace(regex, (match, group) => {
            // check if group contains :, if so replace with a key
            if (group.includes(':'))
            {
                this.matches.push('tempConcatStrings');
                let rand = 'k' + Math.random().toString(36).substring(7);
                this.stringKeys[rand] = group;
                return '!!' + rand + '!!';
            }
            return match;
        });
        template = template.replaceAll('!!', '"');

        return template;
    }

    _replaceConcatStrings(template)
    {
        // sandwiched strings
        let regex1 = /<%=([^+]*) \+ "([^"]+)" \+ ([^%]*)%>/g;
        // leading strings
        let regex2 = /<%=([^%]*)"([^"]+)" \+ ([^%]*)%>/g;
        // trailing strings
        let regex3 = /<%=([^%]*) \+ "([^"]+)"([^%]*)%>/g;

        while (regex1.test(template))
        {
            this.matches.push('concatStrings');
            template = template.replace(regex1, "<%=$1%>$2<%=$3%>");
        }
        while (regex2.test(template))
        {
            this.matches.push('concatStrings');
            template = template.replace(regex2, "<%=$1%>$2<%=$3%>");
        }
        while (regex3.test(template))
        {
            this.matches.push('concatStrings');
            template = template.replace(regex3, "<%=$1%>$2<%=$3%>");
        }

        template = template.replaceAll('%>: <%=', '####');

        return template;
    }

    _cleanupSimpleTernary(template)
    {
        let regex = /(<%=([^?>]+))\?([^:]+):((.*)%>)/g;
        if (regex.test(template)) {
            this.matches.push('simpleTernaryWithColon');
            template = template.replace(regex, "<%=#$2%><%= $3 %><%=/$2%><%=^$2%><%= $5 %><%=/$2%>");
        }
        return template;
    }

    _setFinalConcatStrings(template)
    {
        // replace " wrapped string that are within mustache tags and remove the wrapping quotes and mustache tags
        let regex = /<%=\s+"([^"]*)"\s+%>/g;
        template = template.replace(regex, "$1");
        template = template.replaceAll('!!', '"');
        for (const key in this.stringKeys)
        {
            template = template.replaceAll(key, this.stringKeys[key]);
        }
        return template.replaceAll('####', '%>: <%=');
    }

    testRender()
    {
        const samples = [
            "<%= self.id %>: <%= (self.$_name) ? self.$_name : 'Resource ' + i1 %>",
            // ### charcode
            "Question  <%= String.fromCharCode(Number(i) + 65) %>",
            // has context menu
            "<%= !!val %>",
            "<%= i1 + \" - \" + _.startCase(_.replace(self.type, \"block-\", \"\")) %>",
            "<%= _.startCase(_.replace(self.type, \"block-\", \"\")) %>",
            "<%= watched.useCustomResponses === true ? \"\" : \"include\" %>",
            "<%= item.$_categoryName ? item.$_categoryName : (\"Category \" + i) %>",
            "<%= i1 %>. <%= _.startCase ? _.startCase(self.type) : self.type %>",
            "<%= item.backgroundId + \": \" + item.$_altText %>",
            "<%= self.backgroundId ? self.backgroundId + \": \" + _.truncate(self.$_altText) : \"Background\" %>",
            "<%= self.characterId ? self.characterId + \": \" + self.$_name : \"\" %>",
            "<%= _.upperFirst(self.type) + \" \" + self.conversationPointId + \": \" + _.truncate(self.$_text) %>",
            "<%= self.endPointId ? \"Endpoint: \" + self.endPointId : \"Endpoint\" %>",
            "<%= self.parallaxSetId ? self.parallaxSetId : \"Parallax Set\" %>",
            "(<%= i + 1 %>) <%= _.truncate(item.$_response, {length: 30}) %>",

            
            "<%= i1 %>",
            "<%= !!val %>",
            "<%= _.startCase(_.replace(self.type, \"block-\", \"\")) %>",
            "<%= _.startCase(_.replace(self.type, \"block-\", \"\")) %>",
            "<%= _.upperFirst(self.type) + \" \" + self.conversationPointId + \": \" + _.truncate(self.$_text) %>",

            "<%= i %>",
            "<%= i1 %> - Delta: <%= self.delta %>",
            "<%= i1 %>. <%= _.startCase ? _.startCase(self.type) : self.type %>",
            "<%= i1 + \" - \" + _.startCase(_.replace(self.type, \"block-\", \"\")) %>",
            "<%= item %>",
            "<%= item.$_categoryName ? item.$_categoryName :  (\"Category \" + i)  %>",
            "<%= item.$_name %>",
            "<%= item.$_text %>",
            "<%= item.actorId %>",
            "<%= item.backgroundId %>",
            "<%= item.backgroundId + \": \" + item.$_altText %>",
            "<%= item.endPointId %>",
            "<%= item.id %>",
            "<%= item.title %>",
            "<%= item.uuid %>",
            "<%= item.value %>",
            "<%= self %>",
            "<%= self.$_label %>",
            "<%= self.$_name %>",
            "<%= self.$_term %>",
            "<%= self.$_title %>",
            "<%= self.backgroundId ? self.backgroundId + \": \" + _.truncate(self.$_altText) : \"Background\" %>",
            "<%= self.characterId ? self.characterId + \": \" + self.$_name : \"\" %>",
            "<%= self.code %>",
            "<%= self.endPointId ? \"Endpoint: \" + self.endPointId : \"Endpoint\" %>",
            "<%= self.event %>",
            "<%= self.graphicId %>",
            "<%= self.id %>",
            "<%= self.name %>",
            "<%= self.nodeId %>",
            "<%= self.parallaxSetId ? self.parallaxSetId : \"Parallax Set\" %>",
            "<%= self.value %>",
            "<%= val %>",
            "<%= watched.useCustomResponses === true ? \"\" : \"include\" %>",

            // # SKELETON
            // ## Broken Issues
            // ### Filter
            // This group might be more problematic as it's filtering what appears in the dropdowns based on conditions
            "<% if (item.isCategory) {print(1);} %>",
            "<% if (item.id !== 'graphic') {print(1);} %>",
            "<% if (item.include) {print(1);} %>",
            "<% if(!(item.id === '$_name' || item.id === 'graphic' || item.id === 'id' || item.id === 'topTerm' || item.id === 'appearInTray' || item.id === 'groups' || item.id === 'expertTips')) {print(1);} %>",
            "Panel <%= i1 %> <% if (_.get(self, 'cause.$_title')) { %> (<%= self.cause.$_title %>) <% } %>",
            "<% if(!(item.id === '$_name' || item.id === 'graphic')) {print(1);} %>",
            // ## Headertemplate/ title issues (aka nice to haves)
            // ### Ternary operator
            "<%= self.$_label ? self.$_label : 'Node ' + i1 %>",
            "<%= self.content && self.content.$_title ? self.content.$_title : 'Node ' + i1 %>",
            "<%= self.$_label ? self.$_label : 'Node ' + i1 %>",
            "<%= self.$_title ? self.$_title : 'Node ' + i1 %>",
            "<%= self.$_title ? self.$_title : 'Video ' + i1 %>",
            "<%= self.$_title ? self.$_title : 'Popup ' + i1 %>",
            "<%= self.$_label ? self.$_label : 'Node ' + i1 %>",
            "<%= self.$_label ? self.$_label : 'Path ' + i1 %>",
            "<%= self.$_title ? self.$_label : 'Item ' + i1 %>",
            // ### this is stupid using _get and should have been written w/o it
            "<%= _.get(self, 'number') ? self.number : 'Callout' %>",
            // ### using plus when not neccessary
            "<%= self.id + ': ' + self.$_name %>",
            // ### this is stupid and should have used i1
            "<%= (i + 1) %>: <%= item.$_label %>",
            "<%= (i + 1) + ': ' + item.$_label %>",
            "<%= (i + 1) %>: <%= item.$_title %>",
            "Task <%= i + 1 %>(<%= item.id %>)",
            // ### substr, could use something else
            "<%= item.id + ': ' + item.$_question.substr(0, 50) + '...' %>",
            "<%= item.id + ': ' + item.$_text.substr(0, 50) + '...' %>",
            "<%= self.$_label ? self.$_label : 'Node ' + i1 %>",
            // ### could have used ternary instead
            // # DEFAULT AKA ORIGINAL
            // most of the ones above plus
            // ## capitalize & ternary
            "<%= self.channelId ? _.capitalize(self.channelId) + ' Channel': 'Channel ' + i1 %>",
            // ## using + for no good reason
            "Task <%=i1 %> (<%= self.id + ' ' + self.interaction.type %>)",
            "Video <%= i1 + ': ' + self.id %>",
        ];

        const sampleVars =
        {
            val: true,
            i1: "i1",
            i: 1,
            self: {
                type: "block-type",
                $_label: "label",
                $_title: "title",
                content: {
                    $_title: "title"
                },
                interaction: {
                    type: "type"
                },
                cause: {
                    $_title: "title"
                },
                number: "number",
                id: "id",
                $_name: "name",
                conversationPointId: "conversationPointId",
                characterId: "characterId",
            },
            watched: {
                useCustomResponses: false
            },
            item: {
                $_categoryName: "category",
                $_response: "response",
                $_altText: "altText",
                backgroundId: "backgroundId",
                $_name: "name",
                conversationPointId: "conversationPointId",
                $_text: "text",
                endPointId: "endPointId",
                parallaxSetId: "parallaxSetId",
                isCategory: "true",
                include: true,
                item: "graphic",
                $_question: "question",
                $_label: "label",
                id: "id",
                $_title: "title",
            }
        };

        let matched = 0;
        samples.forEach(template => {

            const orgTemplate = template
            template = this.cleanupTemplate(orgTemplate, sampleVars);
            let result = Mustache.render(template, sampleVars);
            let compiled = _.template(orgTemplate);
            let result2 = compiled(sampleVars);

            if (this.smartCompareResults(result, result2)) {
                matched += 1
            }
            else {
                console.log('---------');
                console.log(orgTemplate);
                console.log(template);
                console.log('-Result M: ', result);
                console.log('-Result U: ', result2);

                console.log('DOES NOT MATCH')
            }
        });

        console.log('TOTAL: ', samples.length)
        console.log('MATCHING: ', matched)
    }

    smartCompareResults(result1, result2)
    {
        let c1 = result1.toLowerCase().trim()
        let c2 = result2.toLowerCase().trim()

        if (c1 === c2)
            return true

        // Compare two strings and only include their differences
        let differences = [];
        for (let i = 0; i < Math.max(c1.length, c2.length); i++) {
            if (c1[i] !== c2[i]) {
                differences.push({ index: i, char1: c1[i] || '', char2: c2[i] || '' });
            }
        }

        // Combine differences into strings
        let diffStr1 = differences.map(diff => diff.char1).join('').trim();
        let diffStr2 = differences.map(diff => diff.char2).join('').trim();

        // compare strings after trimming and compare if the difference is only a space
        if (diffStr1 === diffStr2 || (diffStr1 === '-' && diffStr2 === ''))
            return true

        // if diffStr1 and diffStr2 are numbers and the different between them is 1 it's a valid match
        if (!isNaN(diffStr1) && !isNaN(diffStr2)) {
            let num1 = parseInt(diffStr1, 10);
            let num2 = parseInt(diffStr2, 10);
            if (Math.abs(num1 - num2) === 1) {
                return true;
            }
        }

        let replacedStr = diffStr1.replace(diffStr2, '').trim();

        // Check if the difference is equal to "block-"
        if (replacedStr === "block-") {
            return true;
        }

        return false
    }
}

export default Templater